import { useStateManager } from "@bcm-dev/bcms-vite";
import { FormRowView, TableBody, TableColumnContainer, TableColumnView, TableItemContainer, TableItemTextView, TableView } from "components/shared";
import { UITextInput } from "components/ui";
import React from "react";
import "./styles.css";
import "./mobile.css";


/**
 * @function TASPositivePayCreateTemplateItemTypeMappingWidget
 * @return {React.Component}
 * @exported true
 * @description The Import File Mapping Preview table for the ImportFileMappingPreviewWidget.
 */
export default function TASPositivePayCreateTemplateItemTypeMappingWidget(props) {
    const { data, onChangeCheckTemp } = useStateManager();
    const columns = [{ id: "-1", value: "" }, { id: "0", value: "Issue" }, { id: "1", value: "Stop" }, { id: "2", value: "Void" }];
    const checkTemplate = data.checkTemplate;
    const columnsItems = columns.map(item => {
        return <TableColumnView key={item.id} text={ item.value } />
    }, []);

    return (
        <div className="tas-positive-pay-create-template-item-type-mapping-widget">
            <DesktopWidget columns={ columns } checkTemplate={ checkTemplate } onChangeCheckTemp={ onChangeCheckTemp } />
            <MobileWidget columns={ columns } checkTemplate={ checkTemplate } onChangeCheckTemp={ onChangeCheckTemp }/>
        </div>
    );
}

function DesktopWidget(props) {
    const columns = props.columns;
    const checkTemplate = props.checkTemplate;
    const onChangeCheckTemp = props.onChangeCheckTemp;
    const columnsItems = columns.map(item => {
        return <TableColumnView key={item.id} text={ item.value } />
    }, []);

    return (
        <TableView className="tas-positive-pay-create-template-item-type-mapping-table show-on-desktop">
            <TableColumnContainer>
                { columnsItems }
            </TableColumnContainer>
            <TableBody>
                <Row checkTemplate={ checkTemplate } onChangeCheckTemp={ onChangeCheckTemp } />
            </TableBody>
        </TableView>
    );
}

function MobileWidget(props) {
    const columns = props.columns;
    const checkTemplate = props.checkTemplate;
    const onChangeCheckTemp = props.onChangeCheckTemp;

    return (
        <div className="flex-container flex-vertical show-on-mobile">
            <div className="header">Item Type Mapping</div>
            <FormRowView text="Issue">
                <UITextInput value={ checkTemplate.itemTypeMappingIssue } onChange={ onChangeCheckTemp("itemTypeMappingIssue") } />
            </FormRowView>
            <FormRowView text="Stop">
                <UITextInput value={ checkTemplate.itemTypeMappingStop } onChange={ onChangeCheckTemp("itemTypeMappingStop") } />
            </FormRowView>
            <FormRowView text="Void">
                <UITextInput value={ checkTemplate.itemTypeMappingVoid } onChange={ onChangeCheckTemp("itemTypeMappingVoid") } />
            </FormRowView>
        </div>
    );
}

function Row(props) {
    const checkTemplate = props.checkTemplate;
    const onChangeCheckTemp = props.onChangeCheckTemp ?? (() => {})
    
    return (
        <TableItemContainer>
            <TableItemTextView className="column-item column-one" text={ `Item Type Mapping` } />
            <TableItemTextView className="column-item column-two" 
            text={ <UITextInput value={ checkTemplate.itemTypeMappingIssue } onChange={ onChangeCheckTemp("itemTypeMappingIssue") } /> } />
            <TableItemTextView className="column-item column-three" 
            text={ <UITextInput value={ checkTemplate.itemTypeMappingStop } onChange={ onChangeCheckTemp("itemTypeMappingStop") } /> } />
            <TableItemTextView className="column-item column-four" 
            text={ <UITextInput value={ checkTemplate.itemTypeMappingVoid } onChange={ onChangeCheckTemp("itemTypeMappingVoid") } /> } />
        </TableItemContainer>
    )
}
